module.exports = __webpack_public_path__ + "static/img1-04a7b2418ad8976057907d4c9d34a2b0.jpeg";